/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import { useState, useEffect } from 'react';

import { useAuth } from "./AuthProvider"

//-------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------



export const useUnsecurePost = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);


  const postData = async (path, body) => {
    setError("");
    setIsLoading(true);

    const response = await fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        //Authorization: `Bearer ${token}`,
      },
      body: body,
    });


    setIsLoading(false);

    if (!response.ok) {
      setError(response.statusText); // json.error
    }

    if (response.ok) {
      // Users of this hook will probably have response watched from a useEffect, so return
      // empty object to indicate no data
      let json = {};

      const data = await response.text();
      if ( data.length > 0 ) {
        json = JSON.parse(data);
      }

      setResponse(json);
    }
  };

  return { postData, response, isLoading, error };
};


//-------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------


export const useSecureGet = () => {
  const { session, } = useAuth();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);


  const getData = async (path, query) => {
    setError("");
    setIsLoading(true);

    const response = await fetch(path, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json',
        'PCPAuthorization': session.token
      },
    });


    setIsLoading(false);

    if (!response.ok) {
      setError(response.statusText); // json.error
    }

    if (response.ok) {
      // Users of this hook will probably have response watched from a useEffect, so return
      // empty object to indicate no data
      let json = {};

      const data = await response.text();
      if ( data.length > 0 ) {
        json = JSON.parse(data);
      }

      setResponse(json);
    }
  };

  return { getData, response, isLoading, error };
};



//-------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------

// Taken from https://www.robinwieruch.de/react-hooks-fetch-data/
const useFetchHook = (initialUrl, initialData) => {
  const [url, setUrl] = useState(initialUrl);
  const [body, setBody] = useState(null);
  const [data, setData] = useState(initialData);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);


  useEffect(() => {
    console.log( 'useEffect = start');

    const fetchData = async () => {
      if ( body === null ) {
        console.log( 'useEffect = null');
        return;
      }

      setIsError(false);
      setIsLoading(true);

      try {
        console.log( 'useEffect = pre fetch');

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(body)
        });
  
        console.log( 'useEffect = post');

        // when response was 401 but without the if, it threw an exception
        if  ( response.status !== 401) {
          console.log( 'useEffect = pre response');
          const results = await response.json()
          setData(results);
          console.log( 'useEffect = post response' + JSON.stringify(results));
        }
      } catch (error) {
        let e = error;
        setIsError(true);
      }

      setIsLoading(false);
      console.log( 'useEffect = done');
    };

    fetchData();
  }, [body]);


  return [{ data, isLoading, isError }, setBody];
};


export default useFetchHook;
